"use strict";
(function (global) {

  /**
   * Установить пользовательские статусы для всех объектов, расположенных в папке.
   *
   * @function WebAccess.services.folder.setStatusForAllObjects
   * @param {integer} ИД папки
   * @param {string} Наименование пользовательского статуса
   * @return {Deferred} Специальный deferred-объект.
   * @example
   *
   * //Установить на всех объектах в папке с ИД=1232143 пользовательский статус «Зеленый».
   * WA.services.folder.setStatusForAllObjects( 1232143, "Green");
   */
  global.folder.setStatusForAllObjects = function (folderId, statusName) {
    return global.call("/Folder.asmx/SetStatusForAllObjects", {
      'FolderID': folderId,
      'StatusName': statusName
    });
  };

  /**
   * Создаёт виртуальную папку.
   *
   * @function WebAccess.services.folder.createVirtual
   * @param  {string} folderName Имя папки.
   * @param  {number} contentType Тип контента виртуальной папки.
   * @param  {Array} initialContents Список ссылок на объекты системы, выступающие начальным контентом папки.
   * @return {Deferred<Object>} Результат создания виртуальной папки.
   * @since 5.6.0.1000
   * @see https://api.jquery.com/category/deferred-object/
   */
  global.folder.createVirtual = (folderName, contentType, initialContents) => {
    let d = $.Deferred();

    const service = '/api/FolderService.asmx/CreateVirtualFolder';
    let args = {
      name: folderName,
      contentType: contentType,
      initialContents: initialContents
    }

    WA.SRV.call(service, args).done((res) => {
      d.resolve(res);
    }).fail((res) => {
      d.reject(res);
    });

    return d.promise();
  };

})(window.WebAccess.services);
